module.exports = __webpack_public_path__ + "img/importance.a429dfa6.png";